export class Mail {
    subject = '';
    mailContent = '';
    usersPublicIds:string[] = [];
}